
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/shipments",
      function () {
        return require("private-next-pages/[lang]/shipments.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/shipments"])
      });
    }
  